import React from "react";
import { motion } from "framer-motion";
import {Link} from "react-router-dom";

import BackgroundVideo from "../components/Background-Video";
import PageTitle from "../partials/Page-Title";
import TitleIcon from "../images/header-icons/cyber-recovery.svg";
import BackgroundImage from "../images/landing-page-bg/cyber-recovery.png";

const CyberRecovery = () => {
  return (
      <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="w-screen h-[calc(100vh-172px)] relative top-[120px] 2xl:top-[172px] left-0 m-auto">
        <PageTitle icon={TitleIcon} header="Cyber Recovery" />
        <BackgroundVideo
            image={BackgroundImage}
            imageclasses="absolute top-[0px] 2xl:top-0"
        />
        <div className="h-[calc(100vh-312px)] absolute bottom-0 w-full">
          <motion.div
              whileHover={{
                scale: 0.9,
                backgroundColor: ["#6E2585", "#444444"],
                transition: { duration: 0.3 },
              }}
              className="font-semibold left-[27%] top-[0%] 2xl:top-[9%] rounded-full absolute bg-[#6E2585] w-[180px] h-[180px] 2xl:w-[226px] text-white 2xl:h-[226px] hover:scale-90 flex justify-center items-center align-middle text-base 2xl:text-xl leading-none uppercase font-proxima-nova"
          >
            <Link to="/cyber-recovery/retail-operation">Retail</Link>
          </motion.div>
          <motion.div
              whileHover={{
                scale: 0.9,
                backgroundColor: ["#444444", "#444444"],
                transition: { duration: 0.3 },
              }}
              className="font-semibold left-[59%] 2xl:left-[61%] top-[0] 2xl:top-[9%] rounded-full absolute bg-[#444444] w-[180px] h-[180px] 2xl:w-[226px] text-white 2xl:h-[226px] flex justify-center items-center align-middle text-base 2xl:text-xl leading-none uppercase font-proxima-nova"
          >
              <Link to="/cyber-recovery/healthcare">Healthcare</Link>
          </motion.div>
        </div>
      </motion.div>
  );
};

export default CyberRecovery;
